<template>
  <v-form @submit.prevent="handleSubmit" ref="form" class="loginForm pa-12 ma-auto text-center">
    <div class="loginForm-header mb-12">
      <div class="loginForm-header-logo">
        <img src="@/assets/app-logo.png" alt="Mank Logo">
      </div>
      <div class="loginForm-header-title">
        <h2 class="text-h5 text-bold">
          Forgot password?
        </h2>
        <h2 class="text-h7 text--secondary">
          Enter your email and we'll send you a reset link.
        </h2>
      </div>
    </div>
    <div class="loginForm-body mb-12">
      <MankTextField
        variant="solo"
        v-model="email"
        placeholder="Enter Your Email"
        :rules="emailRules"
        type="email"
        required/>
    </div>

    <v-btn
      color="primary"
      block
      :loading="loading"
      :disabled="!email"
      elevation="0"
      type="submit"
      class="mt-6">
      Send reset link
    </v-btn>

    <div class="mt-6 text-element-2">
      <span
        class="text-primary text-semibold cursor-pointer"
        @click="$router.push('/login')">
        Back to login
      </span>
    </div>
  </v-form>
</template>

<script>
import AuthService from '@/services/AuthService';
import AnalyticsService from '@/services/AnalyticsService';
import { EVENTS } from '@/constants/analyticsEvents';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      loading: false,
      emailRules: [
        (v) => !!v || 'This field is required',
        (v) => /.+@.+\..+/.test(v) || 'Please enter a valid email address',
      ],
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        await AuthService.forgotPassword(this.email);
        AnalyticsService.track(EVENTS.PASSWORD_RESET_REQUESTED);
        this.$store.dispatch('ui/showNotification', {
          type: 'success',
          message: 'If an account exists for this email, you will receive a reset link.',
        }, { root: true });
        this.$router.push('/login');
      } catch {
        // Hata mesajı axios interceptor/store tarafından gösteriliyor
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loginForm {
  border-radius: 16px;
  width: 360px;
  background: $light-surface-2;
}

.cursor-pointer {
  cursor: pointer;
}

::v-deep .v-btn--loader {
  .v-btn__content {
    flex: none;
  }
  .v-btn__loader {
    position: relative;
    left: auto;
    margin-right: 8px;
  }
}

.loginForm ::v-deep .mank-input .v-input__slot {
  border: 1px solid $light-surface-3;
  border-radius: 8px;
}

.loginForm ::v-deep .mank-input.v-input--is-focused .v-input__slot {
  border-color: $light-surface-4;
}
</style>
